import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout'
import Login from '@/views/login'
import Home from '@/views/home/home.vue'

const Register = () => import('@/views/register')
const RegisterList1 = () => import('@/views/register/list1')
const RegisterEdit1 = () => import('@/views/register/list1/edit')
const CardmachinerecordList = () => import('@/views/register/cardmachinerecordlist')
const RegisterPrice = () => import('@/views/register/price')

const CardMachine = () => import('@/views/cardmachine')
const CardMachineList = () => import('@/views/cardmachine/list')
const CardMachineEdit = () => import('@/views/cardmachine/list/edit')


const M4system = () => import('@/views/m4system')
const M4systemList = () => import('@/views/m4system/list')
const M4systemPrice = () => import('@/views/m4system/price')

const Application = () => import('@/views/application')
const Appaccount = () => import('@/views/application/appaccount')
const Applocklist = () => import('@/views/application/applocklist')
const Applockrecord = () => import('@/views/application/applocklist/lockrecord')


const Goods = () => import('@/views/goods')
const GoodsList = () => import('@/views/goods/list')
const GoodsEdit = () => import('@/views/goods/list/edit')
const GoodsTemplateList = () => import('@/views/goods/templatelist')
const GoodsTemplateEdit = () => import('@/views/goods/templatelist/edit')
const GoodsValueList = () => import('@/views/goods/valuelist')
const GoodsValueEdit = () => import('@/views/goods/valuelist/edit')
const GoodsPrice = () => import('@/views/goods/price')


const Order = () => import('@/views/order')
const OrderGoodsList = () => import('@/views/order/goods')


Vue.use(VueRouter)

const routes = [
  {

    path: "/",
    component: Layout,
    meta: {
      isLogin: true
    },
    children: [
      {
        path: "/",
        name: 'home',
        component: Home,
      },
      {
        path: "/register",
        name: 'register',
        component: Register,
        children: [
          {
            path: "register-list1",
            name: 'registerlist1',
            component: RegisterList1,
          },
          {
            path: "register-edit1",
            name: 'registeredit1',
            component: RegisterEdit1,
            meta: {
              activeMenu: '/register/register-list1'
            }
          },
          {
            path: "cardmachinerecord-list",
            name: 'cardmachinerecordlist',
            component: CardmachinerecordList,
          },
          {
            path: "register-price",
            name: 'registeprice',
            component: RegisterPrice,
          },
        ]
      },
      {
        path: "/cardmachine",
        name: 'cardmachine',
        component: CardMachine,
        children: [
          {
            path: "cardmachine-list",
            name: 'cardmachinelist',
            component: CardMachineList,
          },
          {
            path: "cardmachine-edit",
            name: 'cardmachineedit',
            component: CardMachineEdit,
            meta: {
              activeMenu: '/cardmachine/cardmachine-list'
            }
          },
        ]
      },
      {
        path: "/m4system",
        name: 'm4system',
        component: M4system,
        children: [
          {
            path: "m4system-list",
            name: 'm4systemlist',
            component: M4systemList,
          },
          {
            path: "m4system-price",
            name: 'm4systemprice',
            component: M4systemPrice,
          },
        ]
      },
      {
        path: "/application",
        name: 'application',
        component: Application,
        children: [
          {
            path: "appaccount-list",
            name: 'appaccount',
            component: Appaccount,
          },
          {
            path: "applock-list",
            name: 'applocklist',
            component: Applocklist,
          },
          {
            path: "applock-record",
            name: 'applockrecord',
            component: Applockrecord,
            meta: {
              activeMenu: '/application/applock-list'
            }
          },
        ]
      },
      {
        path: "/goods",
        name: 'goods',
        component: Goods,
        children: [
          {
            path: "goods-list",
            name: 'goodslist',
            component: GoodsList,
          },
          {
            path: "goods-edit",
            name: 'goodsedit',
            component: GoodsEdit,
            meta: {
              activeMenu: '/goods/goods-list'
            }
          },
          {
            path: "goods-templatelist",
            name: 'goodstemplatelist',
            component: GoodsTemplateList,
            meta: {
              activeMenu: '/goods/goods-list'
            }
          },
          {
            path: "goods-templateedit",
            name: 'goodstemplateedit',
            component: GoodsTemplateEdit,
            meta: {
              activeMenu: '/goods/goods-list'
            }
          },
          {
            path: "goods-valuelist",
            name: 'goodsvaluelist',
            component: GoodsValueList,
            meta: {
              activeMenu: '/goods/goods-list'
            }
          },
          {
            path: "goods-valueedit",
            name: 'goodsvalueedit',
            component: GoodsValueEdit,
            meta: {
              activeMenu: '/goods/goods-list'
            }
          },
          {
            path: "goods-price",
            name: 'goodsprice',
            component: GoodsPrice,
            meta: {
              activeMenu: '/goods/goods-list'
            }
          },
          
        ]
      },
      {
        path: "/order",
        name: 'order',
        component: Order,
        children: [
          {
            path: "order-goodslist",
            name: 'ordergoodslist',
            component: OrderGoodsList,
          },
          
          
        ]
      },
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router
